var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12343809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1675844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1675843"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 12.2758,
    y: 3.23389,
    width: 0.75218,
    height: 12.7871,
    rx: 0.37609,
    transform: "rotate(45 12.2758 3.23389)",
    fill: "#9A9A9A",
    stroke: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 12.8076,
    y: 12.2759,
    width: 0.75218,
    height: 12.7871,
    rx: 0.37609,
    transform: "rotate(135 12.8076 12.2759)",
    fill: "#9A9A9A",
    stroke: "#9A9A9A"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.557d507c933e61bd1b8f01f11366bdd1.svg";
export { ForwardRef as ReactComponent };